const storage = ($storage: Storage) => {
	const get = (key: string) => {
		let value = $storage.getItem(key);
		try {
			if (value !== null) {
				value = JSON.parse(value);
			}
			return value;
		} catch {
			return value;
		}
	};

	const set = (key: string, value: any) => {
		return $storage.setItem(key, value ? JSON.stringify(value) : value);
	};

	const remove = (key: string) => {
		return $storage.removeItem(key);
	};

	const clearExcept = (key: string) => {
		for (let i = 0; i < $storage.length; i++) {
			const itemKey = $storage.key(i);
			if (itemKey !== null && itemKey !== key) {
				$storage.removeItem(itemKey);
			}
		}
	};

	const clearAll = () => {
		for (const itemKey in $storage) {
			if (itemKey !== null) {
				$storage.removeItem(itemKey);
			}
		}
	};

	return {
		get,
		set,
		remove,
		clearExcept,
		clearAll,
	};
};

const useSessionStorage = storage(window.sessionStorage || sessionStorage);
const useLocalStorage = storage(window.localStorage || localStorage);

export { useSessionStorage, useLocalStorage };
